module.exports = __webpack_public_path__ + "hn.ca21772c.svg";